export default {
  register: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    mobile: 'Mobile',
    country: 'Country',
    company: 'Company',
    verificationCode: 'Verification code',
    selectPlaceholder: 'Please select ',
    inputPlaceholder: 'Please input ',
    invitationCode: 'Invitation code',
    value6digitsRequired: 'The value must be 6 digits',
    password: 'Password',
    repeatpassword: 'Repeat password',
    atLeast6Chars: 'Contains at least 6 characters',
    maximum20Chars: 'A maximum of 20 characters',
    atLeast2Words: 'At least 2 words',
    onlyEnDigit: 'Only the combination of English characters and digits is allowed',
  },
  publicPart: {
    search: {
      searchTitle: 'More Search',
      reset: 'Reset',
      search: 'Search',
      startTime: 'Start time ',
      endTime: 'End time',
      to: 'to',
      selectPlaceholder: 'Please select ',
      inputPlaceholder: 'Please input ',
      keyWord: 'Keyword',
    }
  },
  goodsList: {
    list: {
      batchPublication: 'Batch Publication',
      batchPublicationTip: 'There are no products to select.',
      filterBtnTxt: 'Filter',
      filter: {
        month: 'New Arrival',
        price: 'Price',
        weight: 'Weight',
        time: 'Delivery Time',
        gender: 'Gender',
        season: 'Season',
      }
    },
    tableName: {
      goodsName: 'Goods Name',
      goodsInfo: 'Product Info',
      goodsImg: 'Goods Image',
      category: 'Category',
      type: 'Type',
      total_stock: 'Total Stock',
      attribute: 'Attribute',
      tag: 'Tag',
      keyWord: 'Keyword',
      create_time: 'Created On',
      update_time: 'Updated On',
      operation: 'Operation',
    },
    add: {
      dialogTitle: 'New goods',
      goodsName: 'Goods name',
      selectPlaceholder: 'Please select ',
      inputPlaceholder: 'Please input ',
      category: 'Category',
      barcode: 'Barcode',
      tags: 'Tag',
      keyword: 'Keyword',
      type: 'Attribute/Single',
      goods_desc: 'Description',
      images: 'Images',
      add: 'Add',
      price: 'Price',
      currency: 'Currency',
      stock: 'Stock',
      value: 'Value',
      operation: 'Operation',
      save: 'Save',
      close: 'Close',
    },
    edit: {
      dialogTitle: 'Product info editing',
      goodsName: 'Goods name',
      selectPlaceholder: 'Please select ',
      inputPlaceholder: 'Please input ',
      category: 'Category',
      barcode: 'Barcode',
      tags: 'Tag',
      keyword: 'Keyword',
      type: 'Attribute/Single',
      goods_desc: 'Description',
      images: 'Images',
      add: 'Add',
      price: 'Price',
      currency: 'Currency',
      stock: 'Stock',
      value: 'Value',
      operation: 'Operation',
      save: 'Save',
      close: 'Close',
    },
    detail: {
      dialogTitle: 'Product info details',
      goodsName: 'Goods name',
      selectPlaceholder: 'Please select ',
      inputPlaceholder: 'Please input ',
      category: 'Category',
      barcode: 'Barcode',
      tags: 'Tag',
      keyword: 'Keyword',
      type: 'Attribute/Single',
      goods_desc: 'Description',
      images: 'Images',
      add: 'Add',
      price: 'Price',
      currency: 'Currency',
      stock: 'Stock',
      value: 'Value',
      operation: 'Operation',
      save: 'Save',
      close: 'Close',
    },
    choosePlatform: {
      dialogTitle: 'Platform',
      close: 'Close',
    },
    selectPlatform: {
      dialogTitle: 'Batch Publication',
      store: 'Store',
      template: 'Template',
      vendor: 'Vendor',
      scope: 'Scope',
      status: 'Status',
      statusRadios: {
        draft: 'draft',
        Draft: 'Draft',
        active: 'active',
        Active: 'Active',
        archived: 'archived',
        Archived: 'Archived'
      },
      selectPlaceholder: 'Please select ',
      inputPlaceholder: 'Please input ',
    },
    auth: {
      dialogTitle: 'Platform',
      save: 'Save',
      close: 'Close',
      inputPlaceholder: 'Please input ',
    },
    updateImg: {
      dialogTitle: 'Attribute images',
      save: 'Save',
      close: 'Close',
    },
    shopifyListing: {
      dialogTitle: 'Shopify listing',
      tabName1: 'Product info',
      tabName2: 'Attribute list',
      selectPlaceholder: 'Please select ',
      inputPlaceholder: 'Please input ',
      shop: 'Shop',
      goods_name: 'Goods name',
      category: 'Category',
      barcode: 'Barcode',
      tags: 'Tag',
      keyword: 'Keyword',
      product_type: 'Goods type',
      vendor: 'Vendor',
      published_scope: 'Published scope',
      listing_status: 'Status',
      type: 'Attribute/Single',
      goods_desc: 'Description',
      images: 'Images',
      add: 'Add',
      price: 'Price',
      currency: 'Currency',
      stock: 'Stock',
      value: 'Value',
      operation: 'Operation',
      save: 'Publish',
      close: 'Close',
    },
    shoplazzaListing: {
      dialogTitle: 'Shoplazza listing',
    },
    shoplineListing: {
      dialogTitle: 'Shopline listing',
    },
  },
  shopifyList: {
    tableName: {
      itemID: 'ItemID',
      goodsInfo: 'Product Info',
      goodsImg: 'Goods image',
      goods_name: 'Goods name',
      shop_name: 'Shop name',
      status_cn: 'Status',
      category_name: 'Category',
      vendor: 'Vendor',
      tags: 'Tags',
      create_time: 'Created On',
      scope: 'Scope',
      published_time: 'Published time',
      operation: 'Operation',
    },
    detail: {
      dialogTitle: 'Listing goods detail',
      itemID: 'Goods ID',
      goods_name: 'Goods name',
      shop_name: 'Shop name',
      category_name: 'Category',
      vendor: 'Vendor',
      tags: 'Tags',
      keyword: 'Keyword',
      status: 'Status',
      goods_desc: 'Description',
      images: 'Images',
      price: 'Price',
      currency: 'Currency',
      stock: 'Stock',
      value: 'Value',
      close: 'Close',
      scope: 'Scope',
    }
  },
  storeList: {
    tableName: {
      status: 'Shop status',
      customer_ids: 'Customers',
      platform_id: 'Platform',
      id: 'Shop ID',
      name: 'Shop name',
      open_date: 'Open time',
      create_at: 'Created On',
      authed: 'Authorized/Unauthorized',
      authed_success: 'Authorized',
      customized: 'Customized',
      authed_danger: 'Unauthorized',
      expire_time: 'Expire time',
      operation: 'Operation',
    },
    auth: {
      dialogTitle: 'Store Authorized',
      save: 'Save',
      close: 'Close',
      inputPlaceholder: 'Please input ',
    },
    add: {
      dialogTitle: 'New store',
      dialogTitle_edit: 'Store info editing',
      dialogTitle_detail: 'Store info detail',
      selectPlaceholder: 'Please select ',
      inputPlaceholder: 'Please input ',
      name: 'Store name',
      shop_abbr: 'Abbreviation',
      language: "Language",
      platform_id: 'Platform',
      open_date: 'Open time',
      shop_url: 'Store Url',
      shop_email: 'Store Email',
      save: 'Save',
      close: 'Close',
      tip: 'Tip: After account authorization is successful, the first synchronization data will take less than 30 minutes. Please wait patiently!',
    }
  },
  platformList: {
    tableName: {
      name: 'Platform name',
      code: 'Platform code',
      url: 'Url',
      desc: 'Description',
      sort: 'Sort',
      operation: 'Operation',
    },
    add: {
      dialogTitle: 'New Platform',
      dialogTitle_edit: 'Platform info editing',
      name: 'Name',
      selectPlaceholder: 'Please select ',
      inputPlaceholder: 'Please input ',
      code: 'Code',
      url: 'Url',
      desc: 'Description',
      sort: 'Sort',
      save: 'Save',
      close: 'Close',
    }
  },
  ordersList: {
    tableName: {
      order_sn: 'Order Sn',
      status: 'Order status',
      platform_name: 'Platform',
      shop_name: 'Shop Name',
      id: ' Order ID',
      country: 'Country',
      create_time: 'Created On',
      order_amount: 'Order Amount',
      operation: 'Operation',
      plt_order_sn: 'Order',
      express_name: 'Delivery Method',
      goods_num: 'Items',
      buyer_name: 'Customer',
      goods_items: 'items',
      goods_item: 'item',
      status_name: 'Order Status',
    },
    add: {
      dialogTitle: 'New Order',
      dialogTitle_edit: 'Edit Order',
      dialogTitle_detail: 'Order Detail',
      selectPlaceholder: 'Select',
      inputPlaceholder: 'Input',
      platform_id: 'Platform',
      save: 'Save',
      close: 'Close',
    }
  },
  shoppingCart: {
    title: 'Shopping Cart',
    tableName: {
      item: 'Item',
      price: 'Price',
      quantity: 'Quantity',
      total: 'Total',
      subtotal: 'Subtotal',
      remove: 'Remove',
      removeTip: 'Are you sure you want to remove the item?' 
    },
    checkout: {
      subtotal: 'Subtotal',
      discount: 'Discount',
      total: 'Total',
    }
  },
  downloadList: {
    tableName: {
      itemID: 'ItemID',
      goodsInfo: 'Product Info',
      goodsImg: 'Image',
      category_name: 'Category',
      stock: 'Stock',
      operation: 'Operation',
      downloads: 'Downloads',
      download_time: 'Download time',
    },
  },
  collectionList: {
    tableName: {
      itemID: 'ItemID',
      goodsInfo: 'Product Info',
      goodsImg: 'Image',
      category_name: 'Category',
      stock: 'Stock',
      operation: 'Operation',
      downloads: 'Downloads',
      download_time: 'Download time',
    },
  },
  listingRecord: {
    tableName: {
      dialogTitle:"Listing Record",
      shopName: 'Shop Name',
      batchNo: 'Batch No.',
      totalProduct: 'Total Product',
      success: 'Success',
      fail: 'Fail',
      operation: 'Operation',
      createTime: 'Created On',
      sku: 'SKU',
      status: 'STATUS',
      error: 'ERROR',
    },
  },
};